// src/components/LoadingOverlay/LoadingContext.jsx
import { createContext, useContext, useState, useCallback } from 'react';

const LoadingContext = createContext(null);

/**
 * LoadingProvider
 * - アプリ全体のローディング状態を管理
 */
export const LoadingProvider = ({ children }) => {
  const [loading, setLoadingState] = useState({
    visible: false,
    message: '',
  });

  /**
   * ローディング開始
   */
  const showLoading = useCallback((message = '') => {
    setLoadingState({
      visible: true,
      message,
    });
  }, []);

  /**
   * ローディング終了
   */
  const hideLoading = useCallback(() => {
    setLoadingState({
      visible: false,
      message: '',
    });
  }, []);

  return (
    <LoadingContext.Provider
      value={{
        loading,
        showLoading,
        hideLoading,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

/**
 * useLoading
 * - LoadingContext を使うためのカスタムフック
 */
export const useLoading = () => {
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }

  return context;
};
